import { makeModuleApiInfoSelector, makeModuleI18nSelector } from "@client/content/selectors";
import { type FormFieldInfo } from "@client/controls/Form/component";
import EmailInput from "@client/controls/Inputs/Email/component";
import RadioButtonGroup, {
  DynamicRadioButtonGroup,
  type RadioButtonGroupProps
} from "@client/controls/Inputs/RadioButtonGroup/component";
import { type OptionItem } from "@client/types/Settings";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { createSelector } from "reselect";
import { getActionFromQS, getEmailFromQS } from "../lib";
import { type Unsubscribe } from "../types";

export const makeFieldsSelector = () => {
  const moduleApiInfoSelector = makeModuleApiInfoSelector();
  const i18nSelector = makeModuleI18nSelector();

  return createSelector([i18nSelector, moduleApiInfoSelector], (i18n, apiInfo): FormFieldInfo[] => {
    const fields: FormFieldInfo[] = [];

    const email = getEmailFromQS();
    if (!email) {
      fields.push({
        Component: EmailInput,
        label: i18n.email,
        name: "email",
        defaultValue: "",
        validation: fieldValidation.email,
        isRequired: true
      });
    }

    const action = getActionFromQS();
    if (!action) {
      fields.push({
        Component: RadioButtonGroup,
        label: i18n.unsubscribePreference,
        name: "action",
        defaultValue: "all",
        isRequired: true,
        componentOpts: {
          options: [
            { label: i18n.unsubscribePreferenceAll, value: "all" },
            { label: i18n.unsubscribePreferenceList, value: "list" }
          ] as OptionItem<Unsubscribe.UnsubscribeAction>[],
          orientation: "vertical"
        } as Partial<RadioButtonGroupProps>
      });
    }

    fields.push({
      Component: DynamicRadioButtonGroup,
      label: i18n.unsubscribeReason,
      name: "reason",
      defaultValue: "Unsubscribe",
      isRequired: true,
      componentOpts: {
        apiInfo,
        options: "${baseUrl}/api/v1/user/option/unsubscribeReasons?isPublic=true",
        orientation: "vertical"
      }
    });

    return fields;
  });
};
